import { Component } from '@angular/core';
import { ArticlesService } from '../../services/articles.service';
import { StorageProvider } from '../../services/storage.provider';
import { Profile } from '../../models/profile.model';
import { MetaProvider } from '../../services/meta.provider';
import { PopUp } from '../../models/popup.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-edit-profile',
  templateUrl: 'edit-profile.html',
  styleUrls: ['edit-profile.scss']
})
export class EditProfilePage {
  public avatars: any;
  public error: any;
  public profileNav: any;
  public model = new Profile();
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private artService: ArticlesService,
    private storage: StorageProvider,
    private meta: MetaProvider
  ) {
    this.actRoute.queryParamMap.subscribe(
      params => {
        if (params.get('profile')) {
          this.profileNav = JSON.parse(actRoute.snapshot.queryParams.profile);
          this.model.lastName = this.profileNav.profile_lastName;
          this.model.subscriber_number = this.profileNav.profile_subscriber_number;
          if (this.profileNav.profile_nickName) {
            this.model.nickname = this.profileNav.profile_nickName;
          } else {
            this.model.nickname = this.profileNav.profile_firstName;
          }
        }
      }
    );
  }

  ionViewWillEnter() {
    this.getAllAvatars();
  }

  ionViewDidEnter() {
    this.meta.clearHead();
  }

  getAllAvatars() {
    this.artService.getAvatars().subscribe(
      (response) => { this.avatars = response; },
      (error) => { this.error = ' Vos identifiants ne sont pas reconnus'; }
    );
  }

  chooseAvatar(id) {
    this.model.avatar_id = id;

    this.model.profil_id = this.profileNav.profile_id;
    this.artService.saveProfileGet(this.model, false).subscribe(
      (response) => {
        if (this.model.profil_id === this.storage.getStorage('logged_profile_id')) {
          this.storage.setStorage('logged_profile_avatar', response.profile_avatar_path);
          this.storage.setStorage('logged_profile_nickname', response.profile_nickName);
        }
        this.router.navigate(['profiles']);
      },
      () => this.error = ' Vos identifiants ne sont pas reconnus'
    );
  }

  changeNickName() {
    this.model.profil_id = this.profileNav.profile_id;
    this.artService.saveProfileGet(this.model, false).subscribe(
      (response) => {
        if (this.model.profil_id === this.storage.getStorage('logged_profile_id')) {
          this.storage.setStorage('logged_profile_avatar', response.profile_avatar_path);
          this.storage.setStorage('logged_profile_nickname', response.profile_nickName);
        }
        this.router.navigate(['profiles']);
      },
      () => this.error = ' Vos identifiants ne sont pas reconnus'
    );
  }

  changeAll() {
    this.model.profil_id = this.profileNav.profile_id;
    this.artService.saveProfileGet(this.model, true).subscribe(
      (response) => {
        if (this.model.profil_id === this.storage.getStorage('logged_profile_id')) {
          this.storage.setStorage('logged_profile_avatar', response.profile_avatar_path);
          this.storage.setStorage('logged_profile_nickname', response.profile_nickName);
        }
        this.router.navigate(['profiles']);
      },
      () => this.error = ' Vos identifiants ne sont pas reconnus'
    );
  }

  openConfirmPopUp() {
    this.tempPopUp = true;
    this.popup.type = 'confirmEdit';
  }

  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
    if (message === 'confirm') {
      this.changeAll();
    }
  }
}
